import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomPriceRequest, ShopCart } from "../interfaces/shop-cart.interface";
import { getCart, getCartErpAccountNumber, getCartStore } from "../store/shop-cart.selectors";
import { StoreState } from "../../../../store/store.interface";
import { getCustomPriceCartMagentoApiCall } from "../api/shop-cart.api";
import { getCartItemMagento, getTokenFromMagento } from "./shop-cart-commons";

export const getCustomPriceCart = createAsyncThunk('shopCart/customPrice', async (customPriceRequest: CustomPriceRequest, thunkAPI) =>{
    try {
      const storeCode = getCartStore(thunkAPI.getState() as StoreState);
      let cart: ShopCart;
      const erpAccountNumber = getCartErpAccountNumber(thunkAPI.getState() as StoreState);
      cart = getCart(thunkAPI.getState() as StoreState)!;
      if(erpAccountNumber) {
        const customPrice = await getCustomPriceCartMagentoApiCall(customPriceRequest);
        if(customPrice.custom_price_available) {
          await getTokenFromMagento(thunkAPI);
          cart = await getCartItemMagento(thunkAPI.getState() as StoreState);
        }
      }

      return { ...cart, store: storeCode };
    } catch(error) {
      return thunkAPI.rejectWithValue(error);
    }
  });